

<template>
  <!-- News Page Start -->
  <section class="news_page_area">
    <div class="container">
      <div class="row">
        <div class="col-lg-9">
          <div class="single_news_post">
            <div class="blog_item">
              <div class="blog_image">
                <img src="../../assets/img/blog_2.jpg" alt="blog" />
              </div>
              <div class="blog_text">
                <div class="blog-meta">
                  <p><i class="fas fa-tags"></i> <a href="#">Pizza</a></p>
                  <p><i class="fas fa-calendar-alt"></i> <a href="#">December 9, 2020</a></p>
                  <p><i class="fas fa-comments"></i> <a href="#">122</a></p>
                  <p><i class="fas fa-eye"></i> <a href="#">267</a></p>
                </div>
                <h2>Hot Chessyraw Pasta Make Creator Fact.</h2>
                <p>But I must explain to you how all this mistaken idea of denouncing pleasure and prai.craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer. Fusce quis nulla volutpat, rhoncus ligula ut, pulvinar nisi. In dapibus urna sit amet accumsan tristique. Donec odio ligula, luctus venenatis varius id, tincidunt ac ipsum. Cras commodo, velit nec aliquam dictum, tortor velit dictum ipsum, sed ornare nunc leo nec ipsum.</p>
                <p>dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                <div class="blog-inner-image">
                  <div class="row">
                    <div class="col-lg-6 col-sm-6">
                      <div class="destination-desc-img">
                        <img src="../../assets/img/blog_2.jpg" alt="gallery 1">
                      </div>
                    </div>
                    <div class="col-lg-6 col-sm-6">
                      <div class="destination-desc-img">
                        <img src="../../assets/img/blog_3.jpg" alt="gallery 1">
                      </div>
                    </div>
                  </div>
                </div>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                <blockquote>
                  Cillum aute nisi sunt quis duis. Ad anim non velit nulla elit est excepteur proident excepteur laboris. Elit consectetur culpa enim aliquip tempor.
                </blockquote>
                <p>Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
              </div>
            </div>
            <!--/.end blog item-->
            <div class="comment-list">
              <div class="comment-group-title">
                <h3>Comments (03)</h3>
              </div>
              <div class="single-comment-item">
                <div class="single-comment-box">
                  <div class="main-comment">
                    <div class="author-image">
                      <img src="../../assets/img/4.jpg" alt="author">
                    </div>
                    <div class="comment-text">
                      <div class="comment-info">
                        <h4>david kamal</h4>
                        <ul>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="far fa-star"></i></li>
                        </ul>
                        <p>4 minitues ago</p>
                      </div>
                      <div class="comment-text-inner">
                        <p>Ne erat velit invidunt his. Eum in dicta veniam interesset, harum lupta definitionem. Vocibus suscipit prodesset vim ei, equidem perpetua eu per.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="single-comment-box comment_reply">
                  <div class="main-comment">
                    <div class="author-image">
                      <img src="../../assets/img/5.jpg" alt="author">
                    </div>
                    <div class="comment-text">
                      <div class="comment-info">
                        <h4>Jerix Ablin</h4>
                        <ul>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="far fa-star"></i></li>
                        </ul>
                        <p>12 minitues ago</p>
                      </div>
                      <div class="comment-text-inner">
                        <p>orem ipsum dolor sit amet, consectetur adipisicing elit. Velit omnis animi et iure laudantium vitae, praesentium optio, sapiente distinctio illo? </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="single-comment-box">
                  <div class="main-comment">
                    <div class="author-image">
                      <img src="../../assets/img/4.jpg" alt="author">
                    </div>
                    <div class="comment-text">
                      <div class="comment-info">
                        <h4>david kamal</h4>
                        <ul>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="fas fa-star"></i></li>
                          <li><i class="far fa-star"></i></li>
                        </ul>
                        <p>4 minitues ago</p>
                      </div>
                      <div class="comment-text-inner">
                        <p>Ne erat velit invidunt his. Eum in dicta veniam interesset, harum lupta definitionem. Vocibus suscipit prodesset vim ei, equidem perpetua eu per.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /end comment list -->
            <div class="leave-comment">
              <h3>Leave a Comment</h3>
              <form>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="comment-field">
                      <input class="ns-com-name" name="name" placeholder="Name" type="text">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="comment-field">
                      <input class="ns-com-name" name="email" placeholder="Email" type="email">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="comment-field">
                      <textarea class="comment" placeholder="Comment..." name="comment"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="comment-field">
                      <button type="submit" class="cta_btn">post comment <span></span></button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- /end comment form -->
          </div>
        </div>
        <div class="col-lg-3">
          <div class="sidebar-widget">
            <div class="single-sidebar">
              <form>
                <input type="search" placeholder="Search..." />
                <button type="submit"><i class="fa fa-search"></i></button>
              </form>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Categories</h3>
              <ul class="category">
                <li><a href="#">Chicken</a></li>
                <li><a href="#">Donuts</a></li>
                <li><a href="#">Drinks</a></li>
                <li><a href="#">Fries</a></li>
                <li><a href="#">Pizza</a></li>
                <li><a href="#">Sandwich</a></li>
                <li><a href="#">Uncategorized</a></li>
              </ul>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Tags</h3>
              <ul class="Tags-catagory">
                <li><a href="#">Chicken</a></li>
                <li><a href="#">Donuts</a></li>
                <li><a href="#">Drinks</a></li>
                <li><a href="#">Fries</a></li>
                <li><a href="#">Pizza</a></li>
                <li><a href="#">Sandwich</a></li>
              </ul>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Popular Post</h3>
              <ul class="recent-blog">
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s1.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s2.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s3.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
                <li>
                  <div class="recent-img">
                    <a href="#">
                      <img src="../../assets/img/blog_s1.jpg" alt="recent image">
                    </a>
                  </div>
                  <div class="recent-text">
                    <h4>
                      <a href="#">Your Perfect Burger</a>
                    </h4>
                    <p class="cat_post_date">September 11, 2022</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="single-sidebar">
              <h3 class="sub_title">Archive</h3>
              <ul class="category">
                <li><a href="#">August 2018 <span>(29)</span></a></li>
                <li><a href="#">July 2018 <span>(12)</span></a></li>
                <li><a href="#">June 2018 <span>(22)</span></a></li>
                <li><a href="#">May 2018 <span>(11)</span></a></li>
                <li><a href="#">April 2018 <span>(12)</span></a></li>
              </ul>
            </div>
            <div class="single-sidebar">
              <a href="javascript:;">
                <img src="../../assets/img/promo_add.jpg" alt="img" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- News Page End -->
</template>
<script>
export default {
  name: 'NewsDetailsArea'
}
</script>



// WEBPACK FOOTER //
// src/components/news/NewsDetailsArea.vue